"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useServerPaginator = void 0;
const React = __importStar(require("react"));
const api_1 = require("../api");
function useServerPaginator(endpoint, initialQuery) {
    const [state, setState] = React.useState({
        count: 0,
        prev: false,
        next: false,
        embedded: [],
        query: initialQuery,
    });
    async function paginate(query) {
        setState(await api_1.Api.get(endpoint, query ? { ...state.query, ...query } : state.query));
    }
    async function appendNext() {
        if (state.next) {
            const next = await api_1.Api.get(endpoint, { ...state.query, page: state.query.page + 1 });
            const embedded = [...state.embedded, ...next.embedded];
            setState({ ...next, embedded });
        }
    }
    React.useEffect(() => {
        paginate();
    }, [endpoint, initialQuery.page]);
    return {
        clear: () => {
            setState({ ...state, embedded: [] });
        },
        getPage: () => state.query.page || 1,
        getCount: () => state.count,
        getItems: () => state.embedded,
        getSize: () => state.query.size,
        setSize: (size) => {
            const page = Math.ceil(state.query.page / (size / state.query.size));
            paginate({ size, page: page <= 1 ? 1 : page >= state.count ? state.count : page });
        },
        goTo: (page) => paginate({ page }),
        query: (query) => paginate(query),
        getQuery: () => state.query,
        reload: () => paginate(),
        hasNext: state.next,
        hasPrev: state.prev,
        next: async () => {
            if (state.next) {
                paginate({ page: state.query.page + 1 });
            }
        },
        prev: async () => {
            if (state.prev) {
                paginate({ page: state.query.page - 1 });
            }
        },
        appendNext,
    };
}
exports.useServerPaginator = useServerPaginator;
